export enum TaskStatus {
  TO_STUDY = 'TO_STUDY',
  STUDYING = 'STUDYING',
  REVIEW = 'REVIEW',
  DONE = 'DONE'
}

export enum Priority {
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High'
}

export enum Subject {
  MATH = 'Math',
  CS = 'CS',
  SCIENCE = 'Science',
  HISTORY = 'History',
  LANGUAGE = 'Language',
  OTHER = 'Other'
}

export enum Difficulty {
  EASY = 'easy',
  MEDIUM = 'medium',
  HARD = 'hard'
}

export interface Subtask {
  id: string;
  title: string;
  completed: boolean;
}

export interface Task {
  id: string;
  title: string;
  description: string;
  subject: Subject;
  priority: Priority;
  status: TaskStatus;
  dueDate: string; // ISO String
  createdAt: number;
  aiTips?: string; // For storing Gemini generated tips
  subtasks: Subtask[];
  resources: string[]; // URLs
  completedAt?: string; // ISO String for completion time
  // Smart Task fields
  estimated_minutes?: number;
  actual_minutes?: number;
  difficulty?: Difficulty;
  tags?: string[];
  is_recurring?: boolean;
  recurrence_pattern?: 'daily' | 'weekly' | 'monthly';
  // Project Teams fields
  assigned_to?: string; // User ID of assigned member
  project_id?: string; // Project/Group ID this task belongs to
}

export interface Stats {
  total: number;
  toStudy: number;
  studying: number;
  completed: number;
}

export interface GradeItem {
  id: string;
  name: string;
  weight: number; // Percentage (0-100)
  score: number | null; // Null if not yet graded
  maxScore: number;
}

export interface Course {
  id: string;
  name: string;
  targetGrade: number; // e.g., 90 for A
  gradeItems: GradeItem[];
}

export interface TaskMetaSnapshot {
  subtasks: Subtask[];
  resources: string[];
}

export interface UserSettings {
  retentionHours: number;
  workMinutes: number;
  breakMinutes: number;
}